const LOCAL_STORAGE_KEY = "transcripts";

export const handleLocalStorageList = (data) => {
  const list = localStorage.getItem(LOCAL_STORAGE_KEY);
  const listArray = list ? JSON.parse(list) : [];
  if (data) {
    const index = listArray.findIndex((item) => item.id === data.file_id);
    if (index === -1) {
      listArray.push({
        id: data.file_id,
        title: data.title,
        status: data.report_status,
      });
    } else {
      listArray[index] = {
        id: data.file_id,
        title: data.title,
        status: data.report_status,
      };
    }
  }
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(listArray));
};

export const setLocalTranscriptData = (data) => {
  localStorage.setItem(data.file_id, JSON.stringify(data));
};

export const getLocalTranscriptData = (id) => {
  const storedData = localStorage.getItem(id);
  return storedData ? JSON.parse(storedData) : null;
};

export const clearLocalTranscriptData = (id) => {
  localStorage.removeItem(id);
};

export const LocalStorageManager = ({ data }) => {
  let localStorageData = getLocalTranscriptData(data.file_id);
  if (localStorageData) {
    return localStorageData;
  } else {
    setLocalTranscriptData(data);
    localStorageData = getLocalTranscriptData(data.file_id);
  }
  return localStorageData;
};
